import React from 'react';
import { connect } from 'react-redux';
import { Label, Table } from 'semantic-ui-react';
import HoverActionButtons from '@/components/buttons/HoverActionButtons';
import { editDataset } from '../../actions';
import { resolveCatalogueTemplate } from '../../catalogue/helper';

const DictionaryFieldType = ({
  code,
  category,
  value,
  showEdit,
  canEdit,
  disabled,
  colSpan,
  template,
}) => (
  <Table.Cell colSpan={colSpan}>
    <HoverActionButtons
      canEdit={canEdit}
      showEdit={() => showEdit(category, code, template)}
      value={value}
      editCopyMods="table-cell table-cell--fieldname"
      disabled={disabled}
    >
      <Label basic size="large" className="button-link-block" content={value} />
    </HoverActionButtons>
  </Table.Cell>
);

const mapStateToProps = ({
  catalogues: { templates },
  datasets: { datasets },
}, ownProps) => {
  const { editable, template } = resolveCatalogueTemplate(datasets, templates, ownProps);
  return ({ disabled: !editable, template });
};

const mapDispatchToProps = {
  showEdit: editDataset,
};

export default connect(mapStateToProps, mapDispatchToProps)(DictionaryFieldType);
